import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
class FarmClass {
    $q;
    constructor() {
        this.$q = useQuasar();
    }
    async getList() {
        const response = await this.$q.ws.sendRequest({
            type: 'query',
            iface: 'user',
            method: 'getGlobalTokenList',
            args: {}
        });
        if (response && response.args && response.args.rows) {
            return response.args.rows;
        }
        else
            return null;
    }
}
export default FarmClass;
